import SectionLabel from "./SectionLabel";
import RedactedText from "./RedactedText";
import { FadeUp, MaskLine } from "./Reveal";

const carries = ["You carry vision.", "You make decisions.", "You build.", "You lead.", "You serve."];

export default function Question() {
  return (
    <section data-testid="question-section" className="border-b border-ink/15">
      <div className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-40">
        <SectionLabel testid="question-label">Intelligence Question 01</SectionLabel>

        <h2 className="max-w-4xl font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
          <MaskLine>What do you need to know</MaskLine>
          <MaskLine delay={0.1}>
            before you make <span className="italic text-wine">your next move?</span>
          </MaskLine>
        </h2>

        <div className="mt-16 grid gap-14 md:grid-cols-2 md:gap-10">
          <div className="space-y-3">
            {carries.map((line, i) => (
              <FadeUp key={line} delay={i * 0.07}>
                <p className="font-serif text-2xl text-ink/85 md:text-3xl">{line}</p>
              </FadeUp>
            ))}
          </div>
          <FadeUp delay={0.2} className="max-w-md space-y-6 text-base leading-relaxed text-smoke md:text-lg">
            <p>
              You steward businesses, families, teams, ministries, communities, ideas, and
              assignments. And somewhere between moving, managing, building, and showing up for
              everyone else — it can become difficult to hear clearly.
            </p>
            <p>
              Sometimes the answer isn't another motivational message. Sometimes you don't need more
              information. You need <RedactedText>the right intelligence.</RedactedText>
            </p>
            <p>
              You need to understand where you are. What has changed. What you don't know yet. What
              resources are available to you. Who you need to talk to. And above all —{" "}
              <RedactedText>what Heaven is saying.</RedactedText>
            </p>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
